import React, { Component } from 'react'
import { FormControl, FormHelperText } from 'material-ui/Form'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import PropTypes from 'prop-types'
import Select from 'material-ui/Select'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  helperText: PropTypes.string,
  label: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  optionsList: PropTypes.array.isRequired
}

const styles = theme => ({
  fieldContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column"
  }
})

const menuProps = {
  MenuListProps: {
    style: {
        maxHeight: '10em',
        overflow: 'auto'
    }
  }
}

class FormSelector extends Component {
  render() {
    const {
      classes,
      disabled,
      helperText,
      input,
      label,
      meta: {
        touched,
        error,
      },
      optionsList,
    } = this.props

    return (
      <div className={classes.fieldContainer}>
        <div className="form-field">
          <FormControl fullWidth={true} error={touched && error} disabled={disabled}>
            <InputLabel htmlFor="optionsList">{label}</InputLabel>
            <Select
              data-test-id='optionsList'
              {...input}
              onChange={param => {
                input.onChange(param.target.value)
              }}
              input={<Input id="optionsList" />}
              MenuProps={menuProps}>
              {optionsList.map(option => (
                <MenuItem data-test-id='stockQuestions' key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{touched && error ? error : helperText}</FormHelperText>
          </FormControl>
        </div>
      </div>
    )
  }
}

FormSelector.propTypes = PROP_TYPES

export default withStyles(styles)(FormSelector)
